import React from 'react'
import Developer from '../components/cards/Developer'

export default function Landing() {
    return <Developer />
}
